import classNames from "classnames";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {} from "lib/components/index";

import {
  Form,
  FormMessage,
  Accordion,
  Button,
  OrderFullDecorator,
  OrderInstallmentDecorator,
  st,
  FormControl,
  FormSection,
} from "lib/index";
import { stateSelector, updateOrder, submit } from "./index";

@connect(
  (state) => ({
    initialOrder: stateSelector(state).initialOrder,
    order: stateSelector(state).order,
    valid: stateSelector(state).valid,
    submitLoading: stateSelector(state).submitLoading,
    saved: stateSelector(state).saved,
    errors: stateSelector(state).errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateOrder,
        submit,
      },
      dispatch
    )
)
export default class EditOrderInstallmentsModalForm extends React.PureComponent {
  componentDidUpdate(prevProps) {
    const { saved, initialOrder, onSave } = this.props;
    if (saved && !prevProps.saved) {
      onSave(initialOrder);
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.submit();
  }

  handleInstallmentsChange(installments) {
    const { order, updateOrder } = this.props;
    updateOrder(
      new OrderFullDecorator({
        ...order,
        installments,
      })
    );
  }

  render() {
    const { onCancel, order, errors, valid, submitLoading, updateOrder } = this.props;

    return (
      order && (
        <Form onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
          {!!errors.base && <FormMessage error={errors.base} />}

          <FormSection.InstallmentsList
            parent={order}
            installments={order.installments}
            name={`order.installments`}
            errors={errors}
            onChange={this.handleInstallmentsChange.bind(this)}
            summary={
              <h3>
                {I18n.t("fe.order_details.to_be_paid_total_amount")}: {st.formatMoney(order.total_amount_sum)}
              </h3>
            }
          />

          <button type="submit" disabled={submitLoading} hidden />
        </Form>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/EditOrderInstallmentsModal/EditOrderInstallmentsModalForm.jsx